<script>
  /* the multipart body provided by craft */

  import removeMd from 'remove-markdown'

  import Image from '/Atoms/Image'
  import Video from '/Atoms/Video'
  import AudioButton from '/Atoms/AudioButton'
  import { numberToUnicodeSupscript } from '/helper'
  import MarkdownBlock from '/Atoms/MarkdownBlock'
  import Footnotes from '/Groups/Footnotes'

  export let body = [], almanac = false

  let footnotes = [], processedBody = []

  function processFootnotes(body) {
    
    const footnotes_regex = /\[fn](.*?)\[\/fn]/g
    let counter = 0
    let footnotes = []

    function processFootnote(match, text) {
      counter++
      let footnote = {
        anchor: `footnote${counter}`,
        number: `${counter}`,
        link:   `#footnote${counter}source`,
        textMd: text.trim()
      }
      let replacement = `<a name="footnote${counter}source"></a>[${numberToUnicodeSupscript(counter)}](#footnote${counter} "${removeMd(text)}")`
      //console.log(replacement)
      footnotes.push(footnote)
      return replacement
    }

    let newBody = []

    for (let block of body) {
      if (block.textBlock) {
        let newBlock = {
          ...block, 
          textBlock: block.textBlock.replaceAll(footnotes_regex, processFootnote)
        }
        newBody.push(newBlock)
      } else {
        newBody.push(block)
      }
    }

    return {
      body: newBody,
      footnotes
    }
  }

  console.log( "<Body>", body.length > 0 ? body : "nothing to do")

  //$: body = processFootnotes(body)

  let result = processFootnotes(body)
  processedBody = result.body || []
  footnotes = result.footnotes


</script>

{#each processedBody as block, index}
  <div class="block" class:first={index === 0}>
    {#if block.typeHandle === "textBlock"}
      <MarkdownBlock source={block.textBlock} article {almanac} first={index === 0} />
    {:else if block.typeHandle === "imageBlock"}
      <Image 
        {almanac}
        src={block.imageBlock?.[0]?.url}
        srcset={`${block.imageBlock?.[0]?.url} 1x, ${block.imageBlock?.[0]?.url2x} 2x`}
        caption={block.imageBlock?.[0]?.imageCaption}
        credits={block.imageBlock?.[0]?.credits}
      />
    {:else if block.typeHandle === "videoBlock"}
      <div class="media">
        <Video 
          vimeoUrl={block.vimeoUrl}
        />
      </div>
    {:else if block.typeHandle === "audioBlock"}
      <div class="media">
        <AudioButton 
          src={block.audioUrl}
          title={block.audioTitle}
        />
      </div>
    {/if}
  </div>
{/each}
{#if footnotes.length > 0}
  <div class="footnotes">
    <Footnotes {footnotes} {almanac} />
  </div>
{/if}

<style lang="scss">
  .block {
    &:not(.first) {
      margin-top: 1em;//30px;
      @include media-small {
        margin-top: 1em;//25px;
      }
    }
  }

  .media {
    padding-bottom: 1em;
    margin: 0 60px;
    @include media-small {
      margin: 0;
    }
  }

  .footnotes {
    margin-top: 2em;
    position: relative;
  }
  .footnotes:before {
    content: " ";
    border-top: 1px solid black;
    height: 1px;
    width: 3em;
    position: absolute;
    top: -0.3em;
    left:0;
  }
</style>